import { useState } from 'react'
import { URL_API } from '../../values/AppConstants'
import Loader from '../loader/Loader'
import useFetchPaginated from '../../networking/useFetchPaginated'
import { useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import FullImage from '../fullimage/FullImage'
import LoaderInLine from '../loader/LoaderInline'
import { Delete } from '../../networking/Delete'

const Demand = () => {
    // const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const { data, isPending, error, hasMore, updateData } = useFetchPaginated(URL_API.getDemand + page)
    const { login } = useSelector(state => state.login)
    const [isLoading, setIsLoading] = useState(false)

    const handleCompleted = async (id) => {
        //change url after building api
        setIsLoading(true)
        const postData = {
            url: URL_API.deleteDemand + id,
            token: login.token
        }
        Delete(postData, responseDelete)
    }
    const responseDelete = (dataObj, error) => {
        setIsLoading(false)
        if (error) {
            alert(error)
            return
        }
        updateData(dataObj.id)
        alert(dataObj.message)
    }

    const fetchMore = () => {
        setPage(p => p + 1)
    }

    const TableRow = ({ item }) => {
        return (
            <tr className='table-row'>
                <td>{item.id}</td>
                <td>{item.name}</td>
                <td className='table-item'>
                    <p style={{ textAlign: 'start' }}>{item.details}</p>
                </td>
                <td>{item.phone_number}</td>
                <td>
                    <p className='table-date'>{item.created_at}</p>
                </td>
                <td>
                    <button className='table-action-complete'
                        onClick={() => handleCompleted(item.id)}>Complete</button>
                </td>
            </tr>
        )
    }

    return (
        <div className="container">
            <Loader show={(page === 1 && isPending) || isLoading} />
            <div className='page-container'>
                <h1 className="page-title">Demands</h1>
                <div className='page-inner-container'>
                    {data &&
                        <InfiniteScroll
                            dataLength={data.length}
                            next={fetchMore}
                            hasMore={hasMore}
                            loader={<LoaderInLine show={isPending} />}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th style={{ textAlign: 'start' }}>Details</th>
                                        <th>Phone</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, i) => <TableRow item={item} key={item.id} />)}
                                </tbody>
                            </table>
                        </InfiniteScroll>
                    }
                </div>
            </div>
        </div>
    );
}

export default Demand;